<div id="keyboard-div">
  <div id="keyboard-modal">
    <div id="keyboard">
      <div id="input-container">
        <input
          ngbAutofocus
          class="form-control"
          [innerHTML]="value"
          #keyValue
          id="input-value"
          type="{{ isPassword }} ? 'password' : 'text'"
          [(ngModel)]="value"
          />
        </div>
        <div id="keyboard-container">
          @for (key of keys; track key; let i = $index) {
            <button
              (click)="onKeyClick(key)"
              class="btn keyboard-key"
          [ngClass]="{
            'btn-150': specialKeys.includes(key),
            'btn-64':
              !specialKeys.includes(key) &&
              !extraSpecialKeys.includes(key) &&
              key != shiftKey &&
              key != spaceKey,
            'btn-99':
              specialKeys.includes(key) &&
              !extraSpecialKeys.includes(key) &&
              key != shiftKey &&
              key != spaceKey,
            'btn-107': extraSpecialKeys.includes(key),
            'btn-175': key == shiftKey,
            'full-btn': key == spaceKey,
            'me-64': i == 26,
            'enter-btn': key == enterKey,
            'selected-btn':
              (key == shiftKey && shift) ||
              (key == altKey && alt) ||
              (key == capsKey && caps)
          }"
              [innerHTML]="key"
            ></button>
          }
        </div>
      </div>
    </div>
  </div>
